import type { DeepPartial, MessageCatalog } from './types';

const kk: DeepPartial<MessageCatalog> = {
  nav: {
    home: 'FalaRus',
    partner: 'Сөйлесу',
    teachers: 'Мұғалімдер',
    stats: 'Статистика',
    profile: 'Профиль',
  },
  profile: {
    tapPhoto: 'Фото таңдау үшін басыңыз',
    premiumDaysLeft: 'Premium · {{days}} күн қалды',
    groups: {
      personal: 'Жеке',
      settings: 'Баптаулар',
      help: 'Көмек',
    },
    rows: {
      profile: 'Профиль',
      certificates: 'Сертификаттар',
      invite: 'Достарды шақыру',
      textSize: 'Мәтін өлшемі',
      notifications: 'Хабарландырулар',
      darkMode: 'Қараңғы режим',
      language: 'Тіл',
      sound: 'Дыбыс және діріл',
      help: 'Көмек',
      pricing: 'Тарифтер',
      paymentHistory: 'Төлем тарихы',
      logout: 'Шығу',
    },
    firstName: 'Аты',
    lastName: 'Тегі',
    save: 'Сақтау',
    cancel: 'Болдырмау',
    nameUpdated: 'Аты жаңартылды',
    avatarUpdated: 'Профиль фотосы жаңартылды',
    avatarUploadFailed: 'Фото жүктелмеді',
    nameRequired: 'Аты мен тегі толтырылуы керек',
  },
  common: {
    user: 'Пайдаланушы',
    save: 'Сақтау',
    cancel: 'Болдырмау',
  },
  language: {
    selectTitle: 'Тілді таңдаңыз',
    selectSubtitle: 'Интерфейс тілі',
  },
  auth: {
    benefits: {
    },
    register: 'Тіркелу',
    logIn: 'Кіру',
    logInTitle: 'Кіру',
    createAccountTitle: 'Тіркелу',
    phone: 'Телефон',
    email: 'Email',
    password: 'Құпия сөз',
    createPassword: 'Құпия сөз ойлап табыңыз',
    rewritePassword: 'Құпия сөзді қайта енгізіңіз',
    name: 'Аты',
    surname: 'Тегі',
    emailHint: 'username@gmail.com',
    forgotPassword: 'Құпия сөзді ұмыттыңыз ба?',
    or: 'НЕМЕСЕ',
    continueWithGoogle: 'Google арқылы жалғастыру',
    noAccount: 'Аккаунтыңыз жоқ па? ',
    signUp: 'Тіркелу',
    haveAccount: 'Аккаунтыңыз бар ма? ',
    emailRequired: 'Email енгізу керек',
    emailInvalid: 'Email дұрыс емес',
    phoneInvalid: 'Телефон нөмірі дұрыс емес',
    passwordRequired: 'Құпия сөз енгізу керек',
    passwordMinLength: 'Құпия сөз кемінде 6 таңбадан тұруы керек',
    passwordsMismatch: 'Құпия сөздер сәйкес келмейді',
    nameRequired: 'Аты енгізу керек',
    surnameRequired: 'Тегі енгізу керек',
    termsPrefix: 'Аккаунт ашу арқылы мен ',
    termsOfUse: 'Пайдалану шарттары',
    termsAnd: ' және ',
    privacyPolicy: 'Құпиялылық саясаты',
    termsSuffix: 'мен келісемін.',
    resetTitle: 'Құпия сөзді қалпына келтіру',
    resetSubtitle: 'Email мекенжайыңызға жаңа құпия сөз жібереміз',
    resetSendPassword: 'Жаңа құпия сөз жіберу',
    resetSuccessTitle: 'Email жіберілді',
    resetSuccessSubtitle: 'Есеп бар болса, жаңа құпия сөз email мекенжайыңызға жіберілді',
    networkError: 'Интернет байланысы жоқ. Қайта көріңіз.',
    genericError: 'Қате орын алды',
  },
};

export default kk;
